// 首页公告（Announcements 分类）
// 原 Zendesk 列表地址（首页 HomeAnnouncement 已改走 /xt-app/public/academy-config/list?configType=2；其它入口如 HomeNotice 仍可能使用本请求）：
// `https://spikex.zendesk.com/api/v2/help_center/${lang}/categories/5284067920670-Announcements/articles.json?sort_by=created_at&sort_order=desc`
export function getZendeskNotices(lang) {
  // 原列表请求（保留备查；HomeNotice 等仍依赖下方 fetch）：
  // return fetch(`https://spikex.zendesk.com/api/v2/help_center/${lang}/categories/5284067920670-Announcements/articles.json?sort_by=created_at&sort_order=desc`);
  return fetch(
    `https://spikex.zendesk.com/api/v2/help_center/${lang}/categories/5284067920670-Announcements/articles.json?sort_by=created_at&sort_order=desc`
  ).then(
    (res) => res.json(),
    () => []
  );
}

/**
 * Spikex 学院（Academy 分类）
 * 源管理页（参考）：https://spikex.zendesk.com/knowledge/arrange/categories/5284051234846?brand_id=5156836483742
 * 请求结构与 Announcement 保持一致，额外透传 brand_id 以便 Zendesk 路由到对应品牌的 Help Center。
 * 原 Zendesk 列表地址（首页 HomeAnnouncement 已改走 /xt-app/public/academy-config/list?configType=1）：
 * `https://spikex.zendesk.com/api/v2/help_center/${lang}/categories/5284051234846-Academy/articles.json?sort_by=created_at&sort_order=desc`
 */
export function getZendeskAcademy(lang) {
  // 原列表请求（保留备查）：
  // return fetch(`https://spikex.zendesk.com/api/v2/help_center/${lang}/categories/5284051234846-Academy/articles.json?sort_by=created_at&sort_order=desc`);
  return fetch(
    `https://spikex.zendesk.com/api/v2/help_center/${lang}/categories/5284051234846-Academy/articles.json?sort_by=created_at&sort_order=desc`
  ).then(
    (res) => res.json(),
    () => []
  );
}
